// extracted by mini-css-extract-plugin
module.exports = {"image":"LinkImageCard_image__EcGL3","link":"LinkImageCard_link__3BYCX"};